<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
      @close="beforeClose"
      @submit="confirm"
    class="addStatrgyArticleDialog"
  >
    <statrgy-article-form
      ref="outform"
      @submit="submit"
    ></statrgy-article-form>
  </sliderBarDialogShell>
</template>

<script>
import statrgyArticleForm from "@/components/wx/strategyArticle/statrgyArticleForm";
import {saveArticle} from "@/api/wx/strategyActicle";

export default {
  name: "addStatrgyArticleDialog",
  components: {
    statrgyArticleForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '新增策略文章'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        'strategyId': form.strategyId,
        'contentType': form.contentType,
        'content': form.content,
      }
      saveArticle(params).then((data) => {
        if(data&&data.code&&data.code == 200){
            this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
        
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .addStatrgyArticleDialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
